module.exports = __webpack_public_path__ + "img/nasho-logo.1e5f4e7c.jpg";